import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Number3 = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step3-line-a"
          d="M12 4a8 8 0 100 16 8 8 0 000-16zm0 1.333a6.667 6.667 0 110 13.334 6.667 6.667 0 010-13.334zm-.314 10.774c1.016 0 1.799-.21 2.347-.63.548-.421.821-1.01.821-1.765 0-.52-.162-.932-.488-1.238-.326-.306-.806-.499-1.44-.578v-.032c.537-.129.955-.365 1.252-.709.297-.343.446-.76.446-1.251 0-.587-.236-1.046-.707-1.375-.47-.33-1.112-.494-1.925-.494-.992 0-1.846.257-2.562.773l.768 1.144c.326-.211.622-.36.889-.446.266-.086.529-.129.787-.129.744 0 1.117.298 1.117.892 0 .387-.14.66-.422.82-.281.158-.726.238-1.335.238h-.607V12.6h.597c.658 0 1.138.077 1.44.231.3.154.45.415.45.784 0 .412-.13.711-.392.897-.261.186-.666.28-1.214.28-.358 0-.72-.049-1.085-.146a5.123 5.123 0 01-1.004-.375v1.412c.659.283 1.414.424 2.267.424z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="step3-line-b" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#step3-line-a"></use>
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#step3-line-a"
        ></use>
        <g
          fill={props.color || theme.palette.grey600}
          mask="url(#step3-line-b)"
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step3-solid-a"
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm-.314 12.107c1.016 0 1.799-.21 2.347-.63.548-.421.821-1.01.821-1.765 0-.52-.162-.932-.488-1.238-.326-.306-.806-.499-1.44-.578v-.032c.537-.129.955-.365 1.252-.709.297-.343.446-.76.446-1.251 0-.587-.236-1.046-.707-1.375-.47-.33-1.112-.494-1.925-.494-.992 0-1.846.257-2.562.773l.768 1.144c.326-.211.622-.36.889-.446.266-.086.529-.129.787-.129.744 0 1.117.298 1.117.892 0 .387-.14.66-.422.82-.281.158-.726.238-1.335.238h-.607V12.6h.597c.658 0 1.138.077 1.44.231.3.154.45.415.45.784 0 .412-.13.711-.392.897-.261.186-.666.28-1.214.28-.358 0-.72-.049-1.085-.146a5.123 5.123 0 01-1.004-.375v1.412c.659.283 1.414.424 2.267.424z"
        ></path>
      </defs>
      <g fill={props.color || theme.palette.grey600} fillRule="evenodd">
        <mask id="step3-solid-b" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#step3-solid-a"></use>
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#step3-solid-a"
        ></use>
        <g
          fill={props.color || theme.palette.grey600}
          mask="url(#step3-solid-b)"
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  );
